(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3360],{

/***/ 28923:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-insurance",
      function () {
        return __webpack_require__(57066);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [4775,98,6966,3633,437,9579,8584,3511,4891,6723,4044,7991,1935,8469,7512,3831,2148,8991,3365,6707,3437,4015,8187,6793,4657,8073,340,6206,8218,513,110,9774,8597,8611,9681,1597,500,1285,2346,1516,7556,454,5802,3007,1359,3025,5401,6874,7715,5642,3484,1086,5405,1186,598,9758,179], () => (__webpack_exec__(28923)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);